import { getOrderSetup } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const ORDER_SETUP_LIST = "ORDER_SETUP_LIST";

export const getOrderSetupKey = (marketId: number, verticalId: number) => {
	return [ORDER_SETUP_LIST, marketId, verticalId];
};

export function useOrderSetupListQuery(verticalId: number, marketId: number) {
	return useQuery({
		queryKey: getOrderSetupKey(marketId, verticalId),
		queryFn: processResponse(() => getOrderSetup(marketId!, verticalId)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!marketId,
	});
}
